export default __webpack_public_path__ + "static/media/rainforest2.c5d0cec0.jpg";